"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichAI = void 0;
const react_1 = __importDefault(require("react"));
const enrich_ai_container_1 = require("./enrich-ai.container");
const EnrichAI = () => react_1.default.createElement(enrich_ai_container_1.EnrichAIContainer, null);
exports.EnrichAI = EnrichAI;
exports.default = exports.EnrichAI;
